module.exports = __webpack_public_path__ + "static/media/101408363_270443547435786_4137990265715556352_n.0b0097d6.jpg";